<!-- uiView: nestedPageContent -->
<div class="tab-content" ui-view="nestedPageContent" style="padding: -20px">
  <div class="row">
    <div class="col-md-6  navyCashHeading">NAVY CASH® SERVICE CENTER</div>
    <div class="col-md-6  ">
      <div class="row">
        <div class="col-md-12  lastLogin">LAST LOGGED IN</div>
      </div>
      <div class="row">
        <div class="col-md-12  lastLogin">{{ user.lastLogin }}</div>
      </div>
    </div>
  </div>
  <div *ngIf="!hasSevenSeriesCard && !isUserHoldRoleAgent && !hasMultipleAgentRoles">
    <app-web-alert></app-web-alert>
  </div>
  <div *ngIf="hasSevenSeriesCard">
    <div class="card card-nc  ">
      <div class="card-heading">
        <span class="icon-NC_alert"></span>
        <span class="cardHeaderHeading">Your Account is Almost Setup</span>
      </div>
      <div class="card-body">
        <div id="alert">
          <p class="text-justify" style="white-space: pre-line">
            <span class="ncAlertMessage1">Please visit your local customer service representative
              to pick up your card. After you are issued a card and it is activated please revisit
              the website to log into your account.</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isUserHoldRoleAgent" id="showMessageId" style="display: block;">
    <div class="card card-nc  ">
      <div class="card-heading">
        <span class="icon-NC_alert"></span>
        <span class="cardHeaderHeading">Information Needed</span>
      </div>
      <div class="card-body">
        <div id="hold-role-info">
          <p class="text-justify" style="white-space: pre-line">
            <span class="ncAlertMessage1">
              <p>Your NavyCash Portal access role has not been assigned yet.  Please contact Customer Service to have your new role assigned.</p>           
              <p>The Customer Service Center (CSC) operating hours are Monday through Friday from 6:00 AM to 8:00 PM CT (closed on all Federal Holidays). At 8:00 PM Monday through Friday, 
                the phones will be routed to an after-hours script until opening the next business day. Please call the DISBO phone number below.</p>           
              <p>DISBO Phone Number: <br>
                1-866-6NAVYCASH / 1-866-662-8922 </p>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="hasMultipleAgentRoles" id="showMessageId" style="display: block;">
    <div class="card card-nc  ">
      <div class="card-heading">
        <span class="icon-NC_alert"></span>
        <span class="cardHeaderHeading">Information Needed</span>
      </div>
      <div class="card-body">
        <div id="hold-role-info">
          <p class="text-justify" style="white-space: pre-line">
            <span class="ncAlertMessage1">
              <p>Your NavyCash Portal account has more than one access role assigned. Please contact Customer Service to have your access corrected.</p>           
              <p>The Customer Service Center (CSC) operating hours are Monday through Friday from 6:00 AM to 8:00 PM CT (closed on all Federal Holidays). At 8:00 PM Monday through Friday, 
                the phones will be routed to an after-hours script until opening the next business day. Please call the DISBO phone number below.</p>           
              <p>DISBO Phone Number: <br>
                1-866-6NAVYCASH / 1-866-662-8922 </p>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
